import { EnvironmentType } from '../schema/environment.enum';

export const HOST: Record<EnvironmentType, string> = {
  [EnvironmentType.LOCAL]: 'http://localhost:4200',
  [EnvironmentType.IN_MEMORY]: 'http://localhost:4200',

  [EnvironmentType.DEV]: 'https://portal.dev.talbinah.net',
  [EnvironmentType.TEST]: 'https://portal.test.talbinah.net',
  [EnvironmentType.RE_DESIGN]: 'https://portal.redesign.talbinah.net',

  [EnvironmentType.STAGING]: 'https://portal.staging.talbinah.net',
  [EnvironmentType.UAT]: 'https://portal.uat.talbinah.net',

  [EnvironmentType.LIVE]: 'https://app.talbinah.net',
  [EnvironmentType.PRODUCTION]: 'https://portal.talbinah.net',
};
